import { type EmailProvider } from '@/types/email';

const EMAIL_PROVIDERS: Record<string, EmailProvider> = {
  'gmail.com': {
    key: 'gmail',
    name: 'Gmail',
    url: 'https://mail.google.com',
  },
  'googlemail.com': {
    key: 'gmail',
    name: 'Gmail',
    url: 'https://mail.google.com',
  },
  'outlook.com': {
    key: 'outlook',
    name: 'Outlook',
    url: 'https://outlook.live.com',
  },
  'hotmail.com': {
    key: 'outlook',
    name: 'Outlook',
    url: 'https://outlook.live.com',
  },
  'live.com': {
    key: 'outlook',
    name: 'Outlook',
    url: 'https://outlook.live.com',
  },
  'yahoo.com': {
    key: 'yahoo',
    name: 'Yahoo Mail',
    url: 'https://mail.yahoo.com',
  },
  'icloud.com': {
    key: 'icloud',
    name: 'iCloud Mail',
    url: 'https://www.icloud.com/mail',
  },
};

export function mapEmailToProvider(email: string): {
  provider: EmailProvider | null;
  domain: string;
} {
  const domain = email.split('@')[1]?.toLowerCase() ?? '';

  const provider = EMAIL_PROVIDERS[domain] ?? null;

  return {
    provider,
    domain,
  };
}
